export default function () {
  const widgetName = 'hcCards';
  const widgetOpts = hcCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {

      $(`#${widgetName}`).appendTo('.subThemeHomePage .subPageCards');

      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).removeAttr('target');
        $(this).find('.buttonwrap').remove();
        $(this).append('<div class="overlay"></div>');

        if (data.items[x].URL === null) {
          $(this).removeAttr('href');
        }
      })
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['all'],
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });

}